import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const BorrowerCapacityUtilizationChart: React.FC = () => {
  const data = {
    labels: ['Under-utilized (<50%)', 'Moderate (50-75%)', 'Well-utilized (75-90%)', 'Over-utilized (>90%)'],
    datasets: [
      {
        data: [35, 42, 18, 5],
        backgroundColor: [
          '#ef4444', // red
          '#f59e0b', // orange  
          '#10b981', // green
          '#8b5cf6'  // purple
        ],
        borderWidth: 0,
        cutout: '40%'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        titleColor: '#ffffff',
        bodyColor: '#ffffff',
        borderColor: 'rgba(0, 0, 0, 0.1)',
        borderWidth: 1,
        cornerRadius: 8,
        padding: 12,
        callbacks: {
          label: function(context: any) {
            return `${context.label}: ${context.parsed}%`;
          }
        }
      }
    }
  };

  const legendItems = [
    { label: 'Under-utilized (<50%)', value: '35%', color: '#ef4444' },
    { label: 'Moderate (50-75%)', value: '42%', color: '#f59e0b' },
    { label: 'Well-utilized (75-90%)', value: '18%', color: '#10b981' },
    { label: 'Over-utilized (>90%)', value: '5%', color: '#8b5cf6' }
  ];

  return (
    <div className="h-80 flex items-center">
      <div className="w-1/2">
        <Doughnut data={data} options={options} />
      </div>
      <div className="w-1/2 pl-6">
        <div className="space-y-3">
          {legendItems.map((item, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center">
                <div 
                  className="w-3 h-3 rounded-full mr-3" 
                  style={{ backgroundColor: item.color }}
                ></div>
                <span className="text-sm text-slate-600">{item.label}</span>
              </div>
              <span className="text-sm font-semibold text-slate-800">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BorrowerCapacityUtilizationChart;